export interface LiveSession {
  id: string;
  title: string;
  host: string;
  category: string;
  tags: string[];
  cover: string;
  start: string;
  end: string;
  status: 'live' | 'upcoming' | 'ended';
  viewers: number;
  hot: number;
  summary: string;
  highlights: string[];
}

export const liveSessions: LiveSession[] = [
  {
    id: 'review-morning-baoliao',
    title: '早间爆料速递：昨夜娱乐圈三件大事逐条盘点',
    host: '陆晚晴',
    category: '娱乐爆料',
    tags: ['速递', '每日必看'],
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20amber%20broadcast%20studio%20with%20a%20morning%20talk%20show%20desk%20and%20soft%20bokeh%20studio%20lights%20behind%2C%20rich%20dark%20brown%20tones%2C%20cinematic%20editorial%20photography%2C%20clean%20elegant%20composition%2C%20high%20detail&width=800&height=450&seq=bl-live-01&orientation=landscape',
    start: '09:30',
    end: '10:30',
    status: 'ended',
    viewers: 23600,
    hot: 8612,
    summary:
      '把过去 12 小时里传播最广的三条娱乐动向逐条拆开讲清楚，配上时间线与当事人公开回应，帮你快速跟上节奏。',
    highlights: ['三条主线一次讲完', '时间线可截图留存', '结尾预留 10 分钟答疑'],
  },
  {
    id: 'market-morning-watch',
    title: '盘中直击：早盘异动与资金流向解读',
    host: '沈立',
    category: '财经观察',
    tags: ['盘中', '数据解读'],
    cover:
      'https://readdy.ai/api/search-image?query=Modern%20financial%20news%20studio%20with%20multiple%20market%20data%20screens%20glowing%20in%20amber%20and%20warm%20orange%20light%2C%20dark%20wood%20and%20brass%20tones%2C%20professional%20editorial%20photography%2C%20cinematic%20depth%20of%20field&width=800&height=450&seq=bl-live-02&orientation=landscape',
    start: '10:00',
    end: '11:30',
    status: 'ended',
    viewers: 15200,
    hot: 7230,
    summary:
      '跟随开盘半小时的板块轮动，梳理资金主要流入方向，用通俗语言解释哪些信号值得持续跟踪。',
    highlights: ['开盘半小时复盘', '板块资金流向表', '不构成任何投资建议'],
  },
  {
    id: 'esports-semifinal-preview',
    title: '电竞前线：夏季赛半决赛赛前深度分析',
    host: '阿凯',
    category: '游戏电竞',
    tags: ['赛事', '阵容分析'],
    cover:
      'https://readdy.ai/api/search-image?query=Esports%20commentary%20room%20with%20large%20screens%20showing%20abstract%20game%20charts%20and%20warm%20amber%20accent%20lighting%2C%20dark%20moody%20interior%2C%20cinematic%20editorial%20photography%2C%20detailed%20textures&width=800&height=450&seq=bl-live-03&orientation=landscape',
    start: '12:30',
    end: '14:00',
    status: 'ended',
    viewers: 31400,
    hot: 10420,
    summary:
      '两支队伍近期交手记录、禁用率最高的英雄池、以及教练组可能拿出的第一套阵容，全部摊开来讲。',
    highlights: ['历史交手数据', '英雄池优先级', '现场连麦提问'],
  },
  {
    id: 'home-kitchen-unbox',
    title: '好物开箱：三款热门厨房小家电真香测评',
    host: '林小满',
    category: '生活好物',
    tags: ['开箱', '实测'],
    cover:
      'https://readdy.ai/api/search-image?query=Cozy%20warm%20kitchen%20counter%20with%20small%20home%20appliances%20arranged%20neatly%20and%20amber%20evening%20light%2C%20clean%20minimal%20styled%20product%20photography%2C%20soft%20shadows%2C%20warm%20beige%20and%20brown%20palette&width=800&height=450&seq=bl-live-04&orientation=landscape',
    start: '14:00',
    end: '15:30',
    status: 'ended',
    viewers: 18900,
    hot: 6905,
    summary:
      '同一道菜在三台机器上各做一遍，从噪音、清洁难度到出品口感逐项打分，不吹不黑只看结果。',
    highlights: ['同条件对比实测', '清洁难度排行', '预算档位建议'],
  },
  {
    id: 'tech-roundtable-flagship',
    title: '科技圆桌：新一季旗舰手机到底值不值得换',
    host: '周叙',
    category: '科技前沿',
    tags: ['圆桌', '正在直播'],
    cover:
      'https://readdy.ai/api/search-image?query=Minimal%20tech%20talk%20studio%20with%20smartphones%20on%20a%20warm%20wooden%20podium%20under%20soft%20amber%20spotlights%2C%20dark%20neutral%20background%2C%20editorial%20product%20photography%2C%20high%20detail&width=800&height=450&seq=bl-live-05&orientation=landscape',
    start: '15:30',
    end: '17:00',
    status: 'live',
    viewers: 42700,
    hot: 13380,
    summary:
      '三位长期体验者分别从影像、续航和系统生态出发，聊清楚这一代升级里哪些是真提升、哪些只是参数好看。',
    highlights: ['三位长期用户对谈', '真实续航曲线', '换机时机建议'],
  },
  {
    id: 'sports-focus-link',
    title: '赛事直播间：焦点战赛前连线与首发预测',
    host: '韩枫',
    category: '体育赛事',
    tags: ['焦点战', '连线'],
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20sports%20broadcast%20studio%20with%20stadium%20imagery%20on%20screens%20and%20amber%20key%20lighting%2C%20dark%20elegant%20interior%20with%20wood%20panels%2C%20cinematic%20editorial%20photography%2C%20rich%20detail&width=800&height=450&seq=bl-live-06&orientation=landscape',
    start: '16:30',
    end: '18:00',
    status: 'live',
    viewers: 38600,
    hot: 12010,
    summary:
      '前线记者连线带来最新伤停情况，结合双方最近五场数据，给出本场最可能出现的首发与战术走向。',
    highlights: ['前线记者连线', '伤停与首发预测', '赛后复盘预约'],
  },
  {
    id: 'talk-drama-reunion',
    title: '爆料夜话：那些年我们追过的剧组重聚内幕',
    host: '苏念',
    category: '娱乐爆料',
    tags: ['夜话', '重磅'],
    cover:
      'https://readdy.ai/api/search-image?query=Intimate%20evening%20talk%20show%20set%20with%20velvet%20sofa%20and%20warm%20amber%20lamp%20light%2C%20deep%20brown%20and%20burgundy%20tones%2C%20cinematic%20editorial%20photography%2C%20soft%20shadows%20and%20elegant%20mood&width=800&height=450&seq=bl-live-07&orientation=landscape',
    start: '18:00',
    end: '19:00',
    status: 'upcoming',
    viewers: 0,
    hot: 9120,
    summary:
      '聊一聊经典剧组多年后重聚背后的故事，包括当年的选角反复、片场花絮，以及几位主创近期动向。',
    highlights: ['当年选角内幕', '片场花絮首度公开', '结尾抽签名周边'],
  },
  {
    id: 'emotion-tree-hole',
    title: '情感树洞：如何和一段关系体面地告别',
    host: '温言',
    category: '情感夜话',
    tags: ['来信', '深夜'],
    cover:
      'https://readdy.ai/api/search-image?query=Quiet%20late%20night%20reading%20corner%20with%20a%20single%20warm%20amber%20floor%20lamp%20and%20a%20soft%20armchair%2C%20muted%20brown%20and%20beige%20palette%2C%20calm%20minimal%20editorial%20photography%2C%20gentle%20shadows&width=800&height=450&seq=bl-live-08&orientation=landscape',
    start: '19:00',
    end: '20:30',
    status: 'upcoming',
    viewers: 0,
    hot: 7460,
    summary:
      '挑选本周来信里最有共鸣的三封，聊聊分手前后的沟通边界、情绪处理，以及怎样把告别说得不伤人。',
    highlights: ['本周来信精选', '现场匿名提问', '情绪舒缓小练习'],
  },
  {
    id: 'music-folk-night',
    title: '音乐现场：民谣之夜不插电小型 Live',
    host: '江迟',
    category: '音乐现场',
    tags: ['现场', '不插电'],
    cover:
      'https://readdy.ai/api/search-image?query=Small%20intimate%20acoustic%20live%20music%20stage%20with%20a%20single%20guitar%20and%20warm%20amber%20spotlight%20beam%2C%20dark%20velvet%20curtain%20background%2C%20cinematic%20concert%20photography%2C%20rich%20warm%20tones&width=800&height=450&seq=bl-live-09&orientation=landscape',
    start: '20:00',
    end: '21:00',
    status: 'upcoming',
    viewers: 0,
    hot: 6880,
    summary:
      '一把吉他一盏灯，唱七首老民谣，中间聊聊每首歌写出来的那个瞬间，适合戴上耳机安静听完。',
    highlights: ['七首经典民谣', '创作背景口述', '现场点歌环节'],
  },
  {
    id: 'market-close-review',
    title: '夜盘复盘：今日财经热点全梳理',
    host: '沈立',
    category: '财经观察',
    tags: ['复盘', '汇总'],
    cover:
      'https://readdy.ai/api/search-image?query=Evening%20financial%20review%20desk%20with%20warm%20amber%20desk%20lamp%20and%20charts%20on%20a%20monitor%2C%20dark%20wood%20office%20at%20night%2C%20professional%20editorial%20photography%2C%20cinematic%20mood&width=800&height=450&seq=bl-live-10&orientation=landscape',
    start: '20:30',
    end: '22:00',
    status: 'upcoming',
    viewers: 0,
    hot: 6540,
    summary:
      '把当天影响市场的几条重要消息按重要程度排序，逐条说明它为什么会引起波动，以及明天该关注什么。',
    highlights: ['当日消息分级', '次日关注清单', '观众提问优先回答'],
  },
  {
    id: 'esports-late-ranked',
    title: '深夜电竞：排位冲分实录与意识教学',
    host: '阿凯',
    category: '游戏电竞',
    tags: ['上分', '教学'],
    cover:
      'https://readdy.ai/api/search-image?query=Late%20night%20gaming%20setup%20with%20a%20warm%20amber%20desk%20glow%20and%20headset%20on%20a%20stand%2C%20dark%20cozy%20room%20with%20brown%20tones%2C%20cinematic%20editorial%20photography%2C%20detailed%20texture&width=800&height=450&seq=bl-live-11&orientation=landscape',
    start: '21:00',
    end: '23:00',
    status: 'upcoming',
    viewers: 0,
    hot: 7320,
    summary:
      '边打边讲，把每一次游走和资源的取舍理由说清楚，重点讲中期节奏怎么带，适合卡在同一个段位的观众。',
    highlights: ['边打边讲思路', '中期节奏专题', '录像回看逐帧分析'],
  },
  {
    id: 'review-daily-wrap',
    title: '爆料收官：今日热点回顾与明日预告',
    host: '陆晚晴',
    category: '娱乐爆料',
    tags: ['收官', '预告'],
    cover:
      'https://readdy.ai/api/search-image?query=Late%20evening%20broadcast%20wrap%20up%20desk%20with%20warm%20amber%20accent%20lighting%20and%20a%20soft%20dark%20studio%20background%2C%20elegant%20cinematic%20editorial%20photography%2C%20warm%20brown%20and%20gold%20tones&width=800&height=450&seq=bl-live-12&orientation=landscape',
    start: '22:00',
    end: '22:45',
    status: 'upcoming',
    viewers: 0,
    hot: 5980,
    summary:
      '用二十分钟把今天所有场次的看点浓缩成一份清单，顺便预告明天值得提前设提醒的三场直播。',
    highlights: ['全天看点浓缩', '明日场次预告', '一周排期速览'],
  },
];